import { Alert, Snackbar } from '@mui/material'
import React, { useCallback } from 'react'
import {
  atom,
  useAtom,
  useAtomValue,
  useSetAtom,
} from 'infrastructure/state/jotai.wrapper'

const isOpenAtom = atom(false)
const messageAtom = atom('')
const severityAtom = atom<'info' | 'error' | 'success'>('info')

export function Notify() {
  const [isOpen, setIsOpen] = useAtom(isOpenAtom)
  const onClose = useCallback(() => setIsOpen(false), [setIsOpen])
  const message = useAtomValue(messageAtom)
  const severity = useAtomValue(severityAtom)
  return (
    <Snackbar
      anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
      open={isOpen}
      autoHideDuration={6000}
      onClose={onClose}
    >
      <Alert
        elevation={6}
        variant="filled"
        severity={severity}
        onClose={onClose}
      >
        {message}
      </Alert>
    </Snackbar>
  )
}

export function useNotify() {
  const setMessage = useSetAtom(messageAtom)
  const setOpen = useSetAtom(isOpenAtom)
  const setSeverity = useSetAtom(severityAtom)
  return useCallback(
    (message: string, options?: { type: 'error' | 'info' | 'success' }) => {
      setMessage(message)
      setSeverity(options?.type ?? 'info')
      setOpen(true)
    },
    [setMessage, setOpen, setSeverity],
  )
}
